import {Injectable} from '@angular/core';
import {BehaviorSubject, combineLatestWith, of} from 'rxjs';
import {map} from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import {ManagementStoreService} from './management-store.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {AttributeGroup} from '@emm/core/models/attribute-group.model';
import {Actions} from '@ngrx/effects';
import {genericSort} from '@emm/core/util/sort.util';
import {GenericItem} from '@emm/core/models/context-menu-action.model';

@Injectable({providedIn: 'root'})
export class AttributeGroupsFacadeService {

    attributeGroups$ = this.api.getAllAttributeGroups();
    attributeGroupDetail$ = new BehaviorSubject<any>(null);
    updatedAttributeGroup$ = new BehaviorSubject<any>(null);
    attributeGroupsAsGenericItems$ = this.attributeGroups$.pipe(
        map(attributeGroups => attributeGroups
            .sort(genericSort(a => a['id']))
            .map(attributeGroup => (
                {
                    name: attributeGroup.name,
                    tag: attributeGroup.id,
                    disabled: false,
                    source: attributeGroup
                } as GenericItem<AttributeGroup>
            ))));

    centerLoading$ = of(false);
    rightLoading$ = this.managementStore.isLoading$.base;
    anyLoading$ = this.rightLoading$.pipe(combineLatestWith(this.centerLoading$),
        map((sources: boolean[]) => R.any(R.equals(true), sources)));

    constructor(private managementStore: ManagementStoreService,
                private actions$: Actions,
                public api: ManagementApiService) {
    }

    selectAttributeGroup(attributeGroup: AttributeGroup) {
        let attributeGroupDetail;
        this.api.getAttributeGroup(attributeGroup).subscribe(result => {
            attributeGroupDetail = result;
            this.attributeGroupDetail$.next(attributeGroupDetail);
        });
    }

    updateAttributeGroup(oldAttributeGroup: AttributeGroup) {
        this.attributeGroupDetail$.next(oldAttributeGroup);
    }

    startProgressBar(): void {
        this.managementStore.dispatch.startLoading();

    }
    stopProgressBar(): void {
        this.managementStore.dispatch.stopLoading();
    }
}
